import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { parsePath } from 'history';
import { resolve } from './url';
export function useNavigate() {
    const history = useHistory();
    const fromURL = useLocation();
    const navigate = useCallback((to, options = { replace: false }) => {
        const toURL = typeof to === 'string' ? parsePath(to) : to;
        const pathname = resolve(fromURL.pathname, toURL.pathname);
        const destination = pathname;
        const toLocation = Object.assign(Object.assign({}, toURL), { state: options.state, pathname: destination });
        history[options.replace ? 'replace' : 'push'](toLocation);
    }, [fromURL.pathname, history]);
    return navigate;
}
export function useLocationState(defaultValue) {
    var _a;
    const location = useLocation();
    const history = useHistory();
    const setState = useCallback((patch) => {
        const nextState = Object.assign(Object.assign({}, location.state), patch);
        const nextLocation = Object.assign(Object.assign({}, location), { state: nextState });
        history.replace(nextLocation);
    }, [history, location]);
    return [(_a = location.state) !== null && _a !== void 0 ? _a : defaultValue, setState];
}
//# sourceMappingURL=navigate.js.map